import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { formatNumber } from '@angular/common';

@Pipe({
  name: 'sarCurrency'
})
export class SarCurrencyPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private locale: string) {}

  transform(value: number | string | null | undefined, digits: string = '1.0-2'): string {
    const numeric = Number(value);
    if (value === null || value === undefined || isNaN(numeric)) {
      return '0';
    }
    return formatNumber(numeric, this.locale || 'ar-SA', digits);
  }
}
